import { Box, Typography } from "@mui/material";
import Banner from "./banner";
import FeaturedCreators from "./featuredCreators";
import FeaturedCourses from "./featuredCourses";
import { useAuth } from "../../hooks/useAuth";
import CallToAction from "./callToAction";
import CreatePersonaForm from "../creatorOnBoarding/createPersonaForm";

const LandingPage: React.FC = () => {
  const { authUser, authLoading } = useAuth();
  const showForm = !authUser && !authLoading;
  const sidebarWidth = 360;

  return (
    <Box sx={{ display: "flex", width: "100%", pb: 3, flexDirection: { xs: "column", md: "row" }, }}>

           {/* ─── Fixed Right-Hand Form ─────────────────────────────────── */}
            {showForm && (
              <Box
                component="aside"
                sx={{
                  order: { xs: 0, md: 1 },
                  height: "100vh",
                  flex: "0 0 35%",
                  p: 2,
                  boxSizing: "border-box",
                  position: { xs: 'relative', md: 'sticky' },
                  top: 0,
                  overflowY: { xs: 'auto', md: 'hidden' },
                  bgcolor: "background.paper",
                  pl: 2, 
                }}
              >
                <CreatePersonaForm />
              </Box>
            )}

      {/* ─── Main Scrollable Content ──────────────────────────────── */}
      <Box
        component="main"
        sx={{
          flex: showForm ? "0 0 65%" : "1 0 100%",
          overflowY: "auto",
          px: { xs: 2, md: 4 }, 
        }}
      >
        <Box textAlign="center" my={5}>
          <Typography variant="h4">
            Your Expertise. Always Available.
          </Typography>
          <Typography variant="body1" color="text.secondary" mt={2}>
            Create a digital version of yourself or your brand, available 24/7 for coaching, Q/A, customer support, monetization and more.
          </Typography>
        </Box>
        
        <Box my={5}>
          <FeaturedCreators />
        </Box>
        <Banner />
        <Box my={5}>
          <FeaturedCourses />
        </Box>
        {(!authUser || authUser.userType === "fan") && <CallToAction />}
      </Box>

    </Box>
  );
};

export default LandingPage;
